<template>
  <div>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>Clé</th>
          <th><span class="sr-only">Priority</span></th>
          <th>Titre</th>
          <th>Fournisseur</th>
          <th>Date butoir</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='ticket in tickets' class="row-hover" :key="ticket.ticket_id">
          <router-link class="nav-link" tag="td" v-text="ticket.ticket_id" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
          <router-link class="nav-link" tag="td" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}">
            <priority-icon v-if="ticket.priority" :priority="ticket.priority"></priority-icon>
          </router-link>
          <router-link class="nav-link" tag="td" v-text="ticket.title" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
          <router-link class="nav-link" tag="td" v-text="ticket.serviceprovider" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}"></router-link>
          <router-link class="nav-link" tag="td" :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}">
            <small v-if="ticket.due_date"
              class="ticket-due-date text-muted"
              :class="{ 'text-danger': isDatePassed(ticket.due_date), 'text-dark': isDateSoon(ticket.due_date) }"
            >{{moment(ticket.due_date).format('YYYY-MM-DD')}}</small>
          </router-link>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import PriorityIcon from './PriorityIcon.vue'

export default {
  name: 'MyLifecycleTickets',
  props: {
    tickets: {},
  },
  components: {
    PriorityIcon
  },
  methods: {
    isDatePassed(dateStr) {
      return this.moment.utc(dateStr).isBefore(this.moment().subtract(1, 'days'))
    },
    isDateSoon(dateStr) {
      return !this.isDatePassed(dateStr) && this.moment.utc(dateStr).isBefore(this.moment().add(5, 'days'))
    }
  }
}
</script>
